import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './EditorControls.scss';

function EditorControls({
  onCancel = () => null,
  onClear = () => null,
  onSynthesise = () => null,
  isEmptyEditor,
  hasProjects,
  isLoading,
  isValidationError = false,
}) {
  return (
    <section className="retro-synthesis-editor-controls">
      <ButtonWithIcon
        type="borderless"
        size="small"
        sprite="Trash"
        linkIconSize="s"
        iconRight
        onClick={onClear}
        disabled={isEmptyEditor}
        className="u-els-margin-left e2e-draw-structure-clear">
        Clear
      </ButtonWithIcon>

      <ButtonWithIcon
        type="tertiary"
        size="small"
        sprite="Close"
        linkIconSize="s"
        iconRight
        onClick={onCancel}
        disabled={!hasProjects}
        className="u-els-margin-left e2e-draw-structure-cancel">
        Cancel
      </ButtonWithIcon>

      <ButtonWithIcon
        type="primary"
        size="small"
        sprite="ChevronRight"
        linkIconSize="s"
        iconRight
        onClick={onSynthesise}
        disabled={isEmptyEditor || isLoading || isValidationError}
        className="u-els-margin-left draw-structure-synthesize">
        Synthesize
      </ButtonWithIcon>
    </section>
  );
}

EditorControls.propTypes = {
  onCancel: PropTypes.func,
  onClear: PropTypes.func,
  onSynthesise: PropTypes.func,
  hasProjects: PropTypes.bool,
  isEmptyEditor: PropTypes.bool,
  isLoading: PropTypes.bool,
  isValidationError: PropTypes.bool,
};

export default EditorControls;
